'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["referenceResolverContext", "forwardedRef"];
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import * as React from 'react';
import makeDecoratorDisplayName from 'reference-resolvers/lib/makeDecoratorDisplayName';
import curry from 'transmute/curry';
import { referenceResolverContextPropTypes } from './ReferenceResolversContext';
import withReferenceResolverContext from './withReferenceResolverContext';
import { jsx as _jsx } from "react/jsx-runtime";
const ConnectReferenceResolvers = (mapResolversToProps, Component, options = {}) => {
  class ConnectResolvers extends React.Component {
    render() {
      const _this$props = this.props,
        {
          referenceResolverContext: resolvers,
          forwardedRef
        } = _this$props,
        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return /*#__PURE__*/_jsx(Component, Object.assign({
        ref: forwardedRef
      }, rest, mapResolversToProps(resolvers, rest)));
    }
  }
  ConnectResolvers.propTypes = Object.assign({}, referenceResolverContextPropTypes, {
    forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      current: PropTypes.object
    })])
  });
  const ContextConnector = withReferenceResolverContext(ConnectResolvers);
  ContextConnector.displayName = makeDecoratorDisplayName('ConnectReferenceResolvers', Component);
  ContextConnector.WrappedComponent = Component;
  if (options.forwardRef) {
    const ForwardedRef = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(ContextConnector, Object.assign({}, props, {
      forwardedRef: ref
    })));
    ForwardedRef.WrappedComponent = ContextConnector.WrappedComponent;
    return ForwardedRef;
  }
  return ContextConnector;
};
export default curry(ConnectReferenceResolvers);